import { render, staticRenderFns } from "./AttachmentInfo.vue?vue&type=template&id=724f8ac9&scoped=true"
import script from "./AttachmentInfo.vue?vue&type=script&lang=js"
export * from "./AttachmentInfo.vue?vue&type=script&lang=js"
import style0 from "./AttachmentInfo.vue?vue&type=style&index=0&id=724f8ac9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f8ac9",
  null
  
)

export default component.exports